import React from 'react';
import Login from 'src/pages/login/Login';
import {
	HashRouter, Routes, Route, Outlet, Navigate,
} from 'react-router-dom';
import LayoutPrincipal from 'src/layouts/LayoutPrincipal';
import LayoutPrivado from 'src/layouts/layout-privado/LayoutPrivado';
import PaginaNoEncontrada from 'src/pages/PaginaNoEncontrada';
import NoAutorizado from 'src/pages/NoAutorizado';
import RutaProtegida from 'src/pages/RutaProtegida';
import RouterGestion from 'src/routers/RouterGestion';
import Registro from 'src/pages/registro/Registro';
import CambiarContrasena from 'src/pages/cambio-contrasena/recuperar-contrasena/Index';
import IndexEnvioCorreoRecuperacion from 'src/pages/cambio-contrasena/mensaje-envio-correo/Index';
import { Roles } from 'src/utils/roles/roles';
import RecepcionHojaDeVida from 'src/pages/formulario-cv/RecepcionHojaDeVida';
import CorreccionDatos from 'src/pages/correccion-datos/CorreccionDatos';
import RouterReportes from './RouterReportes';

function JupiterRouter() {
	return (
		<HashRouter>
			<Routes>
				<Route
					path="/"
					element={(
						<LayoutPrincipal>
							<Outlet />
						</LayoutPrincipal>
					)}
				>
					<Route path="/" element={<Navigate to="/login" />} />
					<Route path="/login" element={<Login />} />
					<Route path="/registro" element={<Registro />} />
					<Route path="/recuperar-contrasena/:token" element={<CambiarContrasena />} />
					<Route path="/completar-informacion/:aspiranteId" element={<CorreccionDatos />} />
					<Route path="/envio-correo-recuperacion" element={<IndexEnvioCorreoRecuperacion />} />
					<Route path="/no-autorizado" element={<NoAutorizado />} />					
					<Route path="/recepcion" element={<RecepcionHojaDeVida />} />					
				</Route>
				<Route path="/" element={<RutaProtegida rolesPermitidos={[Roles.ADMIN, Roles.GESTOR]} />}>
						<Route
							path="/"
							element={(
								<LayoutPrivado>
									<Outlet />
								</LayoutPrivado>
							)}
						>
							<Route path="/gestion/*" element={<RouterGestion />} />
							<Route path="/reportes/*" element={<RouterReportes />} />
						</Route>
					</Route>
				<Route path="*" element={<PaginaNoEncontrada />} />
			</Routes>
		</HashRouter>
	);
}

export default JupiterRouter;
